module.exports = __webpack_public_path__ + "img/Avatar-5.0fea9e85.gif";